var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "document-save-list-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
    },
    on: { hide: _vm.handleHide },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("documents.saveAsNewTemplate")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("material-input", {
              attrs: {
                "validator-context": _vm.$v,
                "on-type": true,
                label: _vm.$t("templates.templateName"),
              },
              model: {
                value: _vm.templateName,
                callback: function ($$v) {
                  _vm.templateName = $$v
                },
                expression: "templateName",
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { disabled: _vm.$v.$invalid, loading: _vm.loading },
                on: { click: _vm.handleSaveTemplate },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.save")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }